export class CUrl{  
    constructor(
      public URLList?: any[]) {}
  }